import { AuthXInterceptor } from '../Config/AuthXInterceptor'

export interface UpdateReferralConfigPayload {
  referrerBonusPercentage: number
  welcomeBonusPercentage: number
  maxBonusMajor: number
  isActive: boolean
}

export const referralBXService = {
  // Get all referrals
  index: async (params?: { page?: number; limit?: number; sortOrder?: 'ASC' | 'DESC' }) => {
    return await AuthXInterceptor.get('customer-incentives/referrals', {
      params,
    })
  },

  // Get referral summary
  summary: async () => {
    return await AuthXInterceptor.get('customer-incentives/summary')
  },

  // Get referral config
  getConfig: async () => {
    // return AuthXInterceptor.get('customer-incentives/summary')
    return await AuthXInterceptor.get('customer-incentives/referrals/config')
  },

  // Update referral config
  updateConfig: async (payload: UpdateReferralConfigPayload) => {
    return await AuthXInterceptor.put('customer-incentives/referrals/config', payload)
  },

  // Get single referral
  show: async (referralId: string) => {
    return await AuthXInterceptor.get(`customer-incentives/referrals/${referralId}`)
  },

  exportCSV: async (params?: any) => {
    return await AuthXInterceptor.get('customer-incentives/referrals/csv', {
      params,
      responseType: 'blob',
    })
  },

  // Get referrals by referrer ID
  getByReferrerId: async (referrerResourceId: string, params?: { page?: number; limit?: number; sortOrder?: 'ASC' | 'DESC' }) => {
    return await AuthXInterceptor.get('customer-incentives/referrals', {
      params: {
        ...params,
        referrerResourceId,
      },
    })
  },
}
